import { render, staticRenderFns } from "./StickyBar.vue?vue&type=template&id=3c94f3fa&scoped=true&"
import script from "./StickyBar.vue?vue&type=script&lang=ts&"
export * from "./StickyBar.vue?vue&type=script&lang=ts&"
import style0 from "./StickyBar.vue?vue&type=style&index=0&id=3c94f3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94f3fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Resize,Scroll})
